<tilby-dialog-toolbar
    [hideCancel]="(dialogMode() !== 'type_select' && !disableBack)"
    [hideConfirm]="true"
    title="CASHREGISTER.SPLIT_SALE.TITLE"
    [isBack]="!disableBack && (dialogMode() === 'type_options' || dialogMode() === 'sale_view')"
    (backClick)="goBack()"
    [customActions]="customActions"
>
</tilby-dialog-toolbar>
<tilby-dialog-content>
@switch(dialogMode()) {
    @case("type_select") {
        <div class="tw-h-full tw-flex tw-items-center tw-justify-center">
            <div class="container tw-flex tw-flex-col sm:tw-flex-row tw-gap-8 tw-items-center sm:tw-items-start tw-justify-center sm:tw-justify-evenly tw-px-8">
                <div class="section tw-flex tw-flex-col tw-w-full sm:tw-w-1/3">
                    <button mat-button class="mat-button-toggle-button" (click)="splitByItems()">{{'CASHREGISTER.SPLIT_SALE.BY_ITEMS_BUTTON' | translate}}</button>
                    <p class="tw-text-center">{{'CASHREGISTER.SPLIT_SALE.BY_ITEMS_DESCRIPTION' | translate}}</p>
                </div>
                <div class="section tw-flex tw-flex-col tw-w-full sm:tw-w-1/3">
                    <button mat-button class="mat-button-toggle-button" (click)="splitByCoversOrAmount('by_covers')" [disabled]="disableAmountAndCovers">{{'CASHREGISTER.SPLIT_SALE.BY_COVERS_BUTTON' | translate}}</button>
                    <p class="tw-text-center">{{'CASHREGISTER.SPLIT_SALE.BY_COVERS_DESCRIPTION' | translate}}</p>
                </div>
                <div class="section tw-flex tw-flex-col tw-w-full sm:tw-w-1/3">
                    <button mat-button class="mat-button-toggle-button" (click)="splitByCoversOrAmount('by_amount')" [disabled]="disableAmountAndCovers">{{'CASHREGISTER.SPLIT_SALE.BY_AMOUNT_BUTTON' | translate}}</button>
                    <p class="tw-text-center">{{'CASHREGISTER.SPLIT_SALE.BY_AMOUNT_DESCRIPTION' | translate}}</p>
                </div>
            </div>
        </div>
    }
    @case('type_options') {
        <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
            <div class="tw-flex tw-items-center tw-gap-5">
                @switch(options.type) {
                    @case('by_covers') {
                        <mat-form-field class="tw-w-full" subscriptSizing="dynamic">
                            <mat-label>{{ 'CASHREGISTER.SPLIT_SALE.COVERS' | translate }}</mat-label>
                            <input matInput type="number" min="2" step="1" [(ngModel)]="options.covers" aria-label="covers" />
                        </mat-form-field>
                        <div class="tw-w-1/3">
                            @if(showPrices) {
                                <span>{{previewPeopleTotal() | tilbyCurrency}}</span>
                            } @else {
                                <span>***</span>
                            }
                        </div>
                    }
                    @case('by_amount') {
                        <mat-form-field class="tw-w-full" subscriptSizing="dynamic">
                            <mat-label>{{ 'CASHREGISTER.SPLIT_SALE.AMOUNT' | translate }}</mat-label>
                            <input matInput type="number" min="0.01" class="hidden-value" [style.font-size]="hideAsterisk === true ? '0px' : '16px'" [(ngModel)]="options.amount" aria-label="amount" (ngModelChange)="onPriceChange(options.amount)"/>
                            @if(!showPrices && hideAsterisk) {
                                <span class="hidden-value-text">***</span>
                            }
                        </mat-form-field>
                    }
                }
            </div>
            @if(!splitItemsOnDutchTreat) {
                <mat-form-field class="tw-w-full" subscriptSizing="dynamic">
                    <mat-label>{{ 'CASHREGISTER.SPLIT_SALE.DEPARTMENT' | translate }}</mat-label>
                    <mat-select [(ngModel)]="options.department" [(value)]="options.department">
                        @for(department of departments; track department) {
                            <mat-option [value]="department">{{ department.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="tw-w-full" subscriptSizing="dynamic">
                    <mat-label>{{ 'CASHREGISTER.SPLIT_SALE.SALE_ITEM_NAME' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="options.itemName" maxlength="255" aria-label="item name" />
                </mat-form-field>
            }
        </div>
    }
    @case('sale_view') {
        <div class="tw-flex tw-gap-3 tw-h-full">
            <div class="tw-flex tw-flex-col tw-w-1/2 tw-gap-5">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-font-bold">
                    <span flex hide-xs>{{'CASHREGISTER.SPLIT_SALE.ORIGINAL_AMOUNT' | translate}}</span>
                    @if(showPrices) {
                        <span class="tw-text-[1.5rem] tw-mt-2 md:tw-mt-0">TOT: {{originalSaleAmount() | tilbyCurrency}}</span>
                    } @else {
                        <span class="tw-text-[1.5rem] tw-mt-2 md:tw-mt-0">TOT: ***</span>
                    }
                </div>
                <div class="tw-flex tw-justify-between tw-font-bold">
                    <span>{{'CASHREGISTER.SPLIT_SALE.NUMBER_OF_ITEMS' | translate}}:</span>
                    <span>{{visibleItems(originalSale).length}}</span>
                </div>
                <cdk-virtual-scroll-viewport itemSize="50" class=" tw-overflow-y-auto" [ngClass]="virtualScrollClasses">
                    <div *cdkVirtualFor="let saleItem of visibleItems(originalSale)"
                        class="tw-flex tw-flex-col tw-justify-between tw-py-3 tw-px-2 tw-border-0 tw-border-b tw-border-solid tw-border-b-gray-200"
                        [ngClass]="{ 'sale-item-child': saleItem.sale_item_parent_uuid }"
                        tilbyGestures
                        (swipeRight)="swipeRight(saleItem)"
                        (click)="moveToSplitSale(saleItem)"
                    >
                        <div class="tw-flex tw-justify-between">
                            <div class="tw-font-bold">
                                {{saleItem.name}}
                            </div>
                            <div>
                                @if(showPrices) {
                                    <span class="tw-font-bold">{{saleItem.final_row_price | tilbyCurrency}}</span>
                                } @else {
                                    <span>***</span>
                                }
                                @if(!saleItem.is_group_item && !saleItem.sale_item_parent_uuid) {
                                    <button mat-button class="tw-min-w-[5%] tw-h-6" (click)="splitItem($event, saleItem)">
                                        <mat-icon class="tw-m-0">call_split</mat-icon>
                                    </button>
                                } @else if(dutchTreatSplitMode && saleItem.is_group_item) {
                                    <button mat-button class="tw-min-w-[5%] tw-h-6" (click)="openItemDetailsDialog($event, saleItem)">
                                        <mat-icon class="tw-m-0">zoom_in</mat-icon>
                                    </button>
                                }
                            </div>
                        </div>
                        @if(!dutchTreatSplitMode) {
                            <div class="tw-flex tw-items-center tw-justify-between">
                                <div>
                                    <span class="split-sale-badge tw-text-xs">{{saleItem.quantity}}x</span>
                                    @if(showPrices) {
                                        <span class="split-sale-price tw-text-xs">{{saleItem.price | tilbyCurrency}}</span>
                                    } @else {
                                        <span class="split-sale-price tw-text-xs">***</span>
                                    }
                                </div>
                                <div class="tw-text-xs tw-mr-8" [ngClass]="{'tw-mr-8': (!saleItem.is_group_item && !saleItem.sale_item_parent_uuid) || (dutchTreatSplitMode && saleItem.is_group_item) }">
                                    {{saleItem.department.vat?.value}}%
                                </div>
                            </div>
                            <div class="tw-flex tw-flex-col">
                                @for(variation of saleItem.variations; track variation.name) {
                                    <div>
                                        <span class="tw-text-xs">{{variation.name}} - {{variation.value}}</span>
                                    </div>
                                }
                                @for(ingredient of saleItem.ingredients; track ingredient.name) {
                                    <span class="tw-flex tw-justify-between tw-w-2/3">
                                        <div class="tw-flex">
                                            @if(ingredient.type == 'removed') {
                                                <mat-icon class="tw-text-xs">remove</mat-icon>
                                            } @else {
                                                <mat-icon class="tw-text-xs">add</mat-icon>
                                            }
                                            <div class="tw-text-xs">{{(ingredient.quantity ?? 0) > 1 ? (ingredient.quantity ?? 0) + 'x' : ''}} {{ingredient.name?.toLowerCase()}}</div>
                                        </div>
                                        @if(ingredient.price_difference) {
                                            <div class="tw-text-xs">
                                                {{+ingredient.price_difference! | tilbyCurrency}}
                                            </div>
                                        }
                                    </span>
                                }
                                @if(saleItem.notes) {
                                    <div class="tw-text-xs">Note: {{saleItem.notes}}</div>
                                }
                            </div>
                        }
                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
            <div class="tw-flex tw-flex-col tw-w-1/2 tw-gap-5">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-font-bold">
                    <span flex hide-xs>{{'CASHREGISTER.SPLIT_SALE.SPLIT_AMOUNT' | translate}} {{splitIndex}}</span>
                    @if(showPrices) {
                        <span class="tw-text-[1.5rem] tw-mt-2 md:tw-mt-0">TOT: {{splitSaleAmount() | tilbyCurrency}}</span>
                    } @else {
                        <span class="tw-text-[1.5rem] tw-mt-2 md:tw-mt-0">TOT: ***</span>
                    }
                </div>
                <div class="tw-flex tw-justify-between tw-font-bold">
                    <span>{{'CASHREGISTER.SPLIT_SALE.NUMBER_OF_ITEMS' | translate}}:</span>
                    <span>{{visibleItems(splitSale).length}}</span>
                </div>
                <cdk-virtual-scroll-viewport itemSize="50" class="tw-overflow-y-auto" [ngClass]="virtualScrollClasses">
                    <div *cdkVirtualFor="let saleItem of visibleItems(splitSale)"
                        class="tw-flex tw-flex-col tw-justify-between tw-py-3 tw-px-2 tw-border-0 tw-border-b tw-border-solid tw-border-b-gray-200"
                        [ngClass]="{ 'sale-item-child': saleItem.sale_item_parent_uuid }"
                        tilbyGestures
                        (swipeLeft)="swipeLeft(saleItem)"
                        (click)="moveToOriginalSale(saleItem)"
                    >
                        <div class="tw-flex tw-justify-between">
                            <div class="tw-font-bold">
                                {{saleItem.name}}
                            </div>
                            <div>
                                @if(showPrices) {
                                    <span class="tw-font-bold">{{saleItem.final_row_price | tilbyCurrency}}</span>
                                } @else {
                                    <span>***</span>
                                }
                            </div>
                        </div>
                        @if(!dutchTreatSplitMode) {
                            <div class="tw-flex tw-items-center tw-justify-between">
                                <div>
                                    <span class="split-sale-badge tw-text-xs">{{saleItem.quantity}}x</span>
                                    @if(showPrices) {
                                        <span class="split-sale-price tw-text-xs">{{saleItem.price | tilbyCurrency}}</span>
                                    } @else{
                                        <span class="split-sale-price tw-text-xs">***</span>
                                    }
                                </div>
                                <div class="tw-text-xs">
                                    {{saleItem.department.vat?.value}}%
                                </div>
                            </div>
                            <div class="tw-flex tw-flex-col">
                                @for(variation of saleItem.variations; track variation.name) {
                                    <div>
                                        <span class="tw-text-xs">{{variation.name}} - {{variation.value}}</span>
                                    </div>
                                }
                                @for(ingredient of saleItem.ingredients; track ingredient.name) {
                                    <span class="tw-flex tw-justify-between tw-w-2/3">
                                        <div class="tw-flex">
                                            @if(ingredient.type == 'removed') {
                                                <mat-icon class="tw-text-xs">remove</mat-icon>
                                            } @else {
                                                <mat-icon class="tw-text-xs">add</mat-icon>
                                            }
                                            <div class="tw-text-xs">{{(ingredient.quantity ?? 0) > 1 ? (ingredient.quantity ?? 0) + 'x' : ''}} {{ingredient.name?.toLowerCase()}}</div>
                                        </div>
                                        @if(ingredient.price_difference) {
                                            <div class="tw-text-xs">
                                                {{+ingredient.price_difference! | tilbyCurrency}}
                                            </div>
                                        }
                                    </span>
                                }
                                @if(saleItem.notes) {
                                    <div class="tw-text-xs">Note: {{saleItem.notes}}</div>
                                }
                            </div>
                        }
                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
    }
}
</tilby-dialog-content>
